import { render, staticRenderFns } from "./InvoicesTableSections.vue?vue&type=template&id=673caa55&scoped=true"
import script from "./InvoicesTableSections.vue?vue&type=script&lang=js"
export * from "./InvoicesTableSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673caa55",
  null
  
)

export default component.exports